module.exports = __webpack_public_path__ + "static/img/home002.e9e848f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/home002.png
// module id = N9Lq
// module chunks = 0